import type { StateCreator } from 'zustand';
import type { LibraryTab, LibraryItem } from '@/types';

export interface LibrarySlice {
  libraryTabs: LibraryTab[];
  setLibraryTabs: (tabs: LibraryTab[]) => void;
  activeTabSlug: string | null;
  setActiveTabSlug: (slug: string | null) => void;
  libraryItems: LibraryItem[];
  setLibraryItems: (items: LibraryItem[]) => void;
  isLibraryLoading: boolean;
  setIsLibraryLoading: (loading: boolean) => void;
  hasAutoSelectedPreset: boolean;
  setHasAutoSelectedPreset: (selected: boolean) => void;
  shouldScrollToActiveTab: boolean;
  setShouldScrollToActiveTab: (shouldScroll: boolean) => void;
}

export const libraryInitialState = {
  libraryTabs: [] as LibraryTab[],
  activeTabSlug: null as string | null,
  libraryItems: [] as LibraryItem[],
  isLibraryLoading: false,
  hasAutoSelectedPreset: false,
  shouldScrollToActiveTab: false,
};

export const createLibrarySlice: StateCreator<
  LibrarySlice,
  [],
  [],
  LibrarySlice
> = (set) => ({
  ...libraryInitialState,

  setLibraryTabs: (libraryTabs) => set({ libraryTabs }),
  setActiveTabSlug: (activeTabSlug) => set({ activeTabSlug }),
  setLibraryItems: (libraryItems) => set({ libraryItems }),
  setIsLibraryLoading: (isLibraryLoading) => set({ isLibraryLoading }),
  setHasAutoSelectedPreset: (hasAutoSelectedPreset) =>
    set({ hasAutoSelectedPreset }),
  setShouldScrollToActiveTab: (shouldScrollToActiveTab) =>
    set({ shouldScrollToActiveTab }),
});
